/** Summarize FormData for console debugging (no file contents). */
export function describeFormData(formData) {
  const entries = [];
  if (!formData || typeof formData.entries !== 'function') {
    return entries;
  }

  for (const [key, value] of formData.entries()) {
    if (value instanceof File || value instanceof Blob) {
      entries.push({
        key,
        type: value.type || 'blob',
        name: value.name || '(blob)',
        size: value.size,
      });
    } else {
      entries.push({ key, value: String(value) });
    }
  }

  return entries;
}

function findDuplicateKeys(entries) {
  const seen = new Set();
  const duplicates = new Set();
  for (const { key } of entries) {
    if (seen.has(key)) {
      duplicates.add(key);
    }
    seen.add(key);
  }
  return [...duplicates];
}

export function logAudioUploadAttempt({ operation, context, formData }) {
  const fields = describeFormData(formData);
  const duplicateKeys = findDuplicateKeys(fields);

  console.group(`[Audio upload] ${operation} — request`);
  console.log('Context:', context);
  console.log('Endpoint:', operation === 'update' ? '/admin/audio/update' : '/admin/audio/create');
  console.table(fields);
  if (duplicateKeys.length > 0) {
    console.warn(
      'Duplicate FormData keys detected (can cause 500 / validation errors):',
      duplicateKeys
    );
  }
  console.groupEnd();
}

export function logAudioUploadError({ operation, context, error, formData }) {
  console.group(`[Audio upload] ${operation} — FAILED`);
  console.log('Context:', context);
  if (formData) {
    console.table(describeFormData(formData));
  }
  console.error('Message:', error?.response?.data?.message || error?.message);
  console.error('HTTP status:', error?.response?.status);
  console.error('Response data:', error?.response?.data);
  if (error?.response?.data?.error) {
    console.error('Error details:', error.response.data.error);
  }
  if (error?.response?.headers) {
    console.error('Response headers:', error.response.headers);
  }
  console.error('Full error object:', error);
  console.groupEnd();
}
